// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__a3AiR","error":"Textarea_error__3XdtT","readonly":"Textarea_readonly__1eYTt","disabled":"Textarea_disabled__GqWKF"};